import React from "react"

type Props = {
  children: React.ReactNode
  className?: string
  text?: boolean
}
export const Container = ({
  children,
  className = "",
  text = false,
}: Props) => {
  return (
    <div className={`px-7 md:px-12 py-12 sm:py-16 lg:py-20 ${className}`}>
      <div
        className={`${
          text ? "max-w-screen-md" : "max-w-screen-xl"
        } mx-auto space-y-14`}
      >
        {children}
      </div>
    </div>
  )
}
export const Label = ({ text }) => (
  <div className={`uppercase tracking-wide text-center font-medium text-base `}>
    {text}
  </div>
)
export default Container
